<template>
  <div class="chartNum">
    <div class="box-item">
      <li
        :class="{ 'number-item': !isNaN(item), 'mark-item': isNaN(item) }"
        v-for="(item, index) in numList"
        :key="index"
      >
        <span v-if="!isNaN(item)">
          <i :class="!isRefresh ? 'animation' : ''" ref="numberItem">90123456789</i>
        </span>
        <span class="comma" v-else>{{ item }}</span>
      </li>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    num: {
      require: true,
      default: 0,
    },
    isRefresh: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      numList: ['0', '0', '0', '0', '0'], // 默认总数
    };
  },
  watch: {
    num(val) {
      this.toOrderNum(val);
      // this.handlerTest();
    },
    isRefresh() {
      if (this.isRefresh) {
        this.numList = ['9', '9', '9', '9', '9'];
        // this.numList = ['0', '0', '0', '0', '0'];
        this.setNumberTransform(true);
      }
    },
  },
  methods: {
    // 测试数字滚动每过一秒加一
    // handlerTest() {
    //   setTimeout(() => {
    //     console.log('修改num', this.num);
    //     // eslint-disable-next-line vue/no-mutating-props
    //     this.num += 1;
    //   }, 2000);
    // },
    // 设置文字滚动
    setNumberTransform(isReset) {
      const numberItems = this.$refs.numberItem; // 拿到数字的ref，计算元素数量
      // eslint-disable-next-line no-restricted-globals
      const numberArr = this.numList.filter((item) => !isNaN(item));
      // 结合CSS 对数字字符进行滚动,显示订单数量
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < numberItems.length; index++) {
        const elem = numberItems[index];
        elem.style.transition = ' transform 1s linear';
        elem.style.transform = `translate(-50%, -${(numberArr[index] * 1 + 1) * 9.1}%)`;
      }
      if (isReset) {
        setTimeout(() => {
          for (let index = 0; index < numberItems.length; index++) {
            const elem = numberItems[index];
            elem.style.transition = ' transform 0s linear';
            elem.style.transform = 'translate(-50%, -0%)';
          }
          setTimeout(() => {
            this.toOrderNum(this.num);
          }, 10);
        }, 1000);
      }
    },
    // 处理总订单数字
    toOrderNum(num) {
      // eslint-disable-next-line no-param-reassign
      num = num.toString();
      // 把订单数变成字符串
      if (num.length < 5) {
        // eslint-disable-next-line no-param-reassign
        num = `0${num}`; // 如未满五位数，添加"0"补位
        this.toOrderNum(num); // 递归添加"0"补位
      } else if (num.length === 5) {
        // 订单数中加入逗号
        // num = num.slice(0, 2) + ',' + num.slice(2, 5) + ',' + num.slice(5, 8)
        this.numList = num.split(''); // 将其便变成数据，渲染至滚动数组
      } else {
        // 订单总量数字超过八位显示异常
        this.$message.warning('总量数字过大');
      }
      this.setNumberTransform();
    },
  },
};
</script>
<style scoped lang="scss">
/*滚动数字设置*/
.box-item {
    margin: 0 auto;
  position: relative;
//   height: 120px;
  font-size: 38px;
  line-height: 41px;
  text-align: center;
  list-style: none;
  color: #66ffff;
  writing-mode: vertical-lr;
  text-orientation: upright;
  /*文字禁止编辑*/
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;
  /* overflow: hidden; */
}
/* 默认逗号设置 */
.mark-item {
  width: 10px;
  height: 100px;
  margin-right: 5px;
  line-height: 10px;
  font-size: 48px;
  position: relative;
  & > span {
    position: absolute;
    width: 100%;
    bottom: 0;
    writing-mode: vertical-rl;
    text-orientation: upright;
  }
}
/*滚动数字设置*/
.number-item {
  width: 58px;
  height: 65px;
  /* 背景图片 */
  background: url("../../../assets/screen-adapter/数字背景框.png") no-repeat center center;
  background-size: 100% 100%;
  // background: #ccc;
  list-style: none;
  margin-right: 15px;
  // background:rgba(250,250,250,1);
  border-radius: 4px;
  & > span {
    position: relative;
    display: inline-block;
    margin-right: 10px;
    width: 100%;
    height: 100%;
    writing-mode: vertical-rl;
    text-orientation: upright;
    overflow: hidden;
    & > i {
      font-style: normal;
      position: absolute;
      top: 10px;
      left: 50%;
      transform: translate(-50%, 0);
      transition: transform 1s ease-in-out;
      letter-spacing: 10px;
    }
  }
}
.number-item:last-child {
  margin-right: 0;
}
</style>
